
export const FROM_MIDNINGHT_TO_6AM = 'FROM_MIDNINGHT_TO_6AM';
export const ALL_HOURS = "ALL_HOURS";